// BUOC523: Don nhap CRM -> dien san hoa don xuat (ke toan chi do lai roi bam Luu).
import { api } from './api';

export const CRM_ORIGIN = 'https://crm.vattuytemiennam.com';

export interface CrmPrefillItem {
  productId: number;
  name: string;
  unit?: string;
  qty: number;
  price: number;
  discountPercent?: number;
}

export interface CrmPrefill {
  nonce: number;
  draftId: number;
  code: string;
  customerId?: number;
  customerName?: string;
  crmCustomerName?: string;
  saleId?: number;
  saleName?: string;
  deliveryDate?: string;
  deliveryStatus?: number;
  discountValue?: number;
  paid?: number;
  note?: string;
  vatInvoice?: boolean;
  total?: number;
  items: CrmPrefillItem[];
}

export interface PrefillLot {
  id: string | number;
  sku?: string;
  quantity?: number;
  salePrice?: number;
  productId?: number;
  productDetailId?: number;
  productName?: string;
  detailName?: string;
  unitName?: string;
  minPrice?: number;
  inPrice?: number;
  expiryDate?: string | null;
}

export interface PrefillAlloc {
  item: CrmPrefillItem;
  lot: PrefillLot;
  quantity: number;
}

// Chon lo theo han dung gan nhat truoc (FIFO); thieu ton thi bao lai cho ke toan.
export function allocateLots(item: CrmPrefillItem, lots: PrefillLot[]): { allocs: PrefillAlloc[]; missing: number } {
  let need = Number(item.qty) || 0;
  const allocs: PrefillAlloc[] = [];
  for (const lot of lots) {
    if (need <= 0) break;
    const have = Number(lot.quantity ?? 0);
    if (have <= 0 || !lot.sku) continue;
    const take = Math.min(have, need);
    allocs.push({ item, lot, quantity: take });
    need -= take;
  }
  return { allocs, missing: Math.max(0, Math.round(need * 100) / 100) };
}

export async function loadLots(productId: number): Promise<PrefillLot[]> {
  const result = await api<{ items: PrefillLot[] }>(`/api/options/stock-lots?productId=${productId}&limit=50`);
  return result.items ?? [];
}

export function notifyParent(message: Record<string, unknown>): void {
  try {
    if (window.parent && window.parent !== window) window.parent.postMessage(message, CRM_ORIGIN);
  } catch {
    // khong nam trong CRM -> bo qua
  }
}
